import React from "react";
import { Modal, Button } from "react-bootstrap";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  let show = props.showUnclaim;
  let handleClose = props.handleUnclaimClose;
  let handleDelete = props.handleUnclaim;

  return (
      <>
      <div id="deleteModal12">
        <Modal size="md" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Choose the Unclaim Reason</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
            Are you sure want to unclaim the shift?
            </div>
            <div className="mt-5">
              {props.children}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="primary" onClick={handleDelete}>
              UnClaim
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
    </div>
    </>
  );
};
